import React, { useState, useEffect, useRef } from 'react';
import './StickyFooter.css';
import axios from "axios";
import { Link, useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const StickyFooter = ({ schoolId = null }) => {

  const baseUrl = schoolId ? `/${schoolId}` : "";
  const { school_slug } = useParams();
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [footerInView, setFooterInView] = useState(false);
  const observerRef = useRef(null);

  useEffect(() => {
    const finalSchoolSlug = school_slug || "tigps-main";

    axios.get(
      `${baseAPIUrl}api/general_settings/get_general_settings/${finalSchoolSlug}`
    )
      .then(res => {
        if (res.data.status === 1) {
          setInfo(res.data.data.settings);
        }
      })
      .catch(err => console.error("CONTACT API ERROR:", err))
      .finally(() => setLoading(false));
  }, [school_slug]);

  useEffect(() => {
    const footerElement = document.querySelector('footer');

    if (!footerElement) return;

    observerRef.current = new IntersectionObserver(
      ([entry]) => {
        setFooterInView(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    observerRef.current.observe(footerElement);

    return () => {
      if (observerRef.current && footerElement) {
        observerRef.current.unobserve(footerElement);
      }
    };
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible || footerInView) return null;

  const phoneNumber = info?.phone || "+1-408-123-4567";

  return (
    <div className="sticky-footer-container">
      {isOpen && (
        <div className="sticky-footer-card animate-pop-in">
          <a href={`tel:${info?.email}`} className="sticky-footer-phone-badge">
            <i className="fas fa-envelope"></i>
            <span>{info?.email}</span>
          </a>

          <a href={`tel:${info?.phone}`} className="sticky-footer-phone-badgephone">
            <i className="fas fa-phone-alt"></i>
            <span>{phoneNumber}</span>
          </a>
        </div>
      )}

      <button
        className={`sticky-footer-fab-btn ${isOpen ? 'active' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label={isOpen ? "Close contact window" : "Open contact window"}
      >
        {isOpen ? (
          <i className="fas fa-times"></i>
        ) : (
          <i className="fas fa-phone-alt"></i>
        )}
      </button>
    </div>
  );
};

export default StickyFooter;
